import React, { useContext } from 'react';
import ProductListItem from './Product/ProductListItem';
import DropDown from './DropDown';
import { TranslationContext } from "./Context";

function HitList(props) {

    const translation = useContext(TranslationContext);

    const createOptions = (items, create) => {
        const result = [];
        items.map(x => result.push(create(x)));
        return result;
    };

    return (
        <div className="container">
            <div className="row u-mbottom30">
                <div className="col-md-6 col-md-push-3 text-center">
                    <DropDown isClearable={true} onChange={props.onAssemblyGroupChange} id='assemblyGroups' label={translation["TecAlliencePartSearch.ProductList.Category.Title"]}
                        options={createOptions(props.assemblyGroups, (x) => ({ value: x.assemblyGroupNodeId, label: x.assemblyGroupName }))}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <ul className="vehicleProductListComponent-list">
                        {props.hits.articles && props.hits.articles.map(a => {
                            return <ProductListItem linkingTargetType={props.linkingTargetType} key={a.articleNumber} article={a} />;
                        })}
                    </ul>
                    
                </div>
           </div>
        </div>
    );
}

export default HitList;